import { formatDate } from '@frontend/mwm-ui'

import type { ReactElement } from 'react'
import type { IIap } from '~/types/iap'

import FeaturesTable from '../FeaturesTable'

import { IapStatusBadge } from '~/components/Badges'

import './styles.scss'

interface Props {
  iap?: IIap
}

const PanelContent = ({ iap }: Props): ReactElement => {
  return iap ? (
    <div className="iap-product-panel-content">
      <div className="iap-product-panel-content__header">
        <div className="iap-product-panel-content__header__title-container">
          <span className="iap-product-panel-content__header__title">{iap.sku}</span>
        </div>
        <div className="iap-product-panel-content__header__infos">
          {iap.status ? <IapStatusBadge value={iap.status} /> : null}
          {iap.created_at ? <span>Created {formatDate(iap.created_at)} </span> : null}
        </div>
      </div>
      <div className="iap-product-panel-content__separator" />
      <div className="iap-product-panel-content__body">
        {iap.unlockables ? <FeaturesTable features={iap.unlockables} /> : <div>No features</div>}
      </div>
    </div>
  ) : (
    <div />
  )
}

export default PanelContent
